import { serviceApi } from "./api-config"

export const postMuestrasOvitrampasFiltrosVector = async (filters) => {
    try{
        const { data } = await serviceApi.post(`api/procev/ovitrampa/muestrasOvitrampasFiltrosVector`, {...filters})
        return data
    }catch{
        throw new Error('Error al intentar obtener Muestras Ovitrampas Filtros con Vector positivo')
    }
}